import { getQuanmaiApi, postQuanmaiApi } from './proxy'
export default class {
    //获取新闻列表
    GetNewsList(data) {
        return getQuanmaiApi('/Articles/getNewLst', data);
    }
    //根据文章ID获取详情
    getArticleById(data) {
        return getQuanmaiApi("/Articles/getArticleById", data)
    }
    //获取下级分类及类型总数
    GetChildCategory(data) {
        return getQuanmaiApi('/Articles/getChildCategory', data);
    }
    //根据分类id获取列表
    ArticlesList(data){
        return getQuanmaiApi('/Articles/lst', data)
    }
    
    //点赞接口
    ArticlesLike(data) {
        return getQuanmaiApi('/Articles/like', data)
    }
    //文章评论/评论回复接口
    Addcomment(data) {
        return postQuanmaiApi('/Articles/comment', data);
    }
    //评论/回复点赞接口
    commentLike(data) {
        return postQuanmaiApi('/Articles/commentLike', data);
    }
    //获取文章评论/评论回复列表
    GetcommentLst(data) {
        return getQuanmaiApi('/Articles/commentLst', data);
    }
    //根据位置获取推荐分类
    GetRecommCategory(data) {
        return getQuanmaiApi('/Articles/getRecommCategory', data);
    }
}


// WEBPACK FOOTER //
// ./src/service/textService.js